<div class="col-sm-12 my-3 my-md-5">
    <div class="row">
        <div class="col-sm-6">
            <h2>Book Meeting Room</h2>
        </div>
        <div class="col-sm-6">
            <a routerLink="/booked-meeting-rooms" class="ml-2 btn btn-success pull-right">
                <i class="fa fa-chevron-left" aria-hidden="true"></i> Back
            </a>
        </div>
    </div>
    
    <div class="card">
        <div class="row p-5">
                <div class="col-sm-8 border-right">
                    <form [formGroup]="MeetingRoomForm" (submit)="submitMeetingRoom()">
                        <div class="form-group">
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="form-label">Meeting Room*</label>
                                    <mat-select placeholder="Select Meeting Room" formControlName="room_name">
                                        <mat-option value="">Select Meeting Room</mat-option>
                                        <mat-option [value]="mtroom.id" *ngFor="let mtroom of meetingRoomList">{{mtroom.room_name}}</mat-option>
                                    </mat-select>
                                    <div *ngIf="submitted && f.room_name.errors" class="invalid-feedback">
                                        <div *ngIf="f.room_name.errors.required">Meeting Room is required</div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label">Date*</label>
                                    <mat-form-field appearance="fill">
                                        <mat-label>Choose a date</mat-label>
                                        <input matInput readonly formControlName="booking_date" [matDatepicker]="picker">
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                    <div *ngIf="submitted && f.booking_date.errors" class="invalid-feedback">
                                        <div *ngIf="f.booking_date.errors.required">Date is required</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="form-label">From Time*</label>
                                    <input type="time" formControlName="booking_from_time" class="form-control" (change)="get_end_time($event)" />
                                    <div *ngIf="submitted && f.booking_from_time.errors" class="invalid-feedback">
                                        <div *ngIf="f.booking_from_time.errors.required">From Time is required</div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <label class="form-label">To Time*</label>
                                    <input type="time" formControlName="booking_to_time" class="form-control" disabled/>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-md-12">
                                    <label class="form-label">Purpose*</label>
                                    <textarea class="form-control" formControlName="purpose"></textarea>
                                    <div *ngIf="submitted && f.purpose.errors" class="invalid-feedback">
                                        <div *ngIf="f.purpose.errors.required">Purpose is required</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="col-sm-12">
                                <button type="submit" [disabled]="loading" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i> Submit</button>
                            </div>
                        </div> 
                    </form>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <div class="row">
                            <div class="col-md-12">
                                <b><i>Note:</i></b> Meeting room will be booked for only 1 hour at any slot.
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-md-12 text-danger">
                                <b><i>Required Fields:</i></b>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                Meeting Room <br />
                                Date <br />
                                From Time <br />
                                To Time (Auto Capture from From Time)<br />
                                Purpose <br />
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    </div>
</div>
